import { spmfcloudFunctionUrl } from '../../actions/salesforces';

export default null;

export const registerRecordType = () => async (dispatch, getState) => {
    const RecordType = {};
    const { user } = getState();
    const recordTypes = await fetch(`${spmfcloudFunctionUrl}/sf/all-record-type`, {
        mode: 'cors',
        cache: 'no-cache',
        method: 'GET',
        headers: {
            'hash-token': user.siteToken.hash,
        },
    }).then(async (response) => {
        const json = await response.json();
        if (!response.ok) {
            throw new Error(json.message);
        }

        return json;
    });
    recordTypes.records.forEach((recType) => {
        if (recType.SobjectType === 'Person__c') {
            if (recType.Name === 'Beneficiary') {
                RecordType.Beneficiary = recType.Id;
            } else if (recType.Name === 'Household Member') {
                RecordType.Household_Member = recType.Id;
            }
        }
    });

    dispatch({
        type: 'RECORD_TYPE',
        payload: RecordType,
    });
};

export const login = async (username, password, siteToken) => {
    const cleanUsername = username.trim();
    // username = cleanUsername;
    const response = await fetch(`${spmfcloudFunctionUrl}/auth/login`, {
        mode: 'cors',
        body: JSON.stringify({
            username: cleanUsername,
            password,
        }),
        cache: 'no-cache',
        method: 'POST',
        headers: {
            'hash-token': siteToken,
            'Content-Type': 'application/json',
        },
    });

    const json = await response.json();
    if (!response.ok) {
        if (json.validation) {
            const message = json.validation.map((validation, index) => `${index + 1}. ${validation.msg}`);
            throw new Error(message.join('<br />'));
        }
        throw new Error(json.message);
    }

    return {
        type: 'LOGGED_IN',
        payload: {
            user: json.user,
            timestamp: new Date().getTime(),
            key: json.key,
        },
    };
};

export const redirectToHomepage = param => (param);



//////////////////
// WEBPACK FOOTER
// ./src/components/Login/actions.js
// module id = 758
// module chunks = 0